import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { R as y, b as w, P as N, O as D, C as O, T as x, D as b, a as c } from "../../../index-itexpIkB.js";
import { c as d } from "../../../clsx-OuTLNxxd.js";
import { B as s } from "../../../button.types-khNMDxMV.js";
import { I as k } from "../../../icon-BnqXyiyH.js";
import "../icon/iconsList.js";
import { C as I } from "../../../callout-Ci1JZfW6.js";
const j = "_icon_zdinf_79", e = {
  "alert-dialog-overlay": "_alert-dialog-overlay_zdinf_29",
  "dialog-overlay-show": "_dialog-overlay-show_zdinf_1",
  "alert-dialog": "_alert-dialog_zdinf_29",
  "dialog-content-show": "_dialog-content-show_zdinf_1",
  "alert-dialog-title": "_alert-dialog-title_zdinf_66",
  icon: j,
  "icon-success": "_icon-success_zdinf_82",
  "icon-error": "_icon-error_zdinf_85",
  "icon-warning": "_icon-warning_zdinf_88",
  "icon-info": "_icon-info_zdinf_91",
  "alert-dialog-description": "_alert-dialog-description_zdinf_95",
  "alert-dialog-content": "_alert-dialog-content_zdinf_99",
  "callout-container": "_callout-container_zdinf_104",
  "alert-dialog-actions": "_alert-dialog-actions_zdinf_108",
  "dialog-content-slide-up": "_dialog-content-slide-up_zdinf_1"
}, B = {
  success: "verification-check-regular",
  error: "error-regular",
  warning: "warning-regular",
  info: "information-circle-regular"
};
function q({
  children: _,
  dialogTriggerNode: g,
  title: f,
  confirmActionText: h,
  dismissActionText: l,
  onDismissAction: t,
  onConfirmAction: m,
  confirmActionColor: u = "primary",
  iconStatus: r,
  calloutProps: o,
  isOpen: p,
  confirmActionIsLoading: v,
  setIsOpen: z
}) {
  const C = d(e["alert-dialog"]);
  return /* @__PURE__ */ a(y, { open: p, onOpenChange: z, children: [
    /* @__PURE__ */ i(w, { asChild: !0, children: g }),
    /* @__PURE__ */ a(N, { children: [
      /* @__PURE__ */ i(D, { className: e["alert-dialog-overlay"] }),
      /* @__PURE__ */ a(
        O,
        {
          "aria-describedby": void 0,
          className: C,
          onInteractOutside: (n) => n.preventDefault(),
          onPointerDownOutside: (n) => n.preventDefault(),
          onEscapeKeyDown: (n) => n.preventDefault(),
          children: [
            /* @__PURE__ */ a(x, { className: e["alert-dialog-title"], children: [
              r && /* @__PURE__ */ i("div", { className: d(e.icon, e[`icon-${r}`]), children: /* @__PURE__ */ i(k, { color: "inherit", name: B[r], size: "7xl" }) }),
              f
            ] }),
            /* @__PURE__ */ i(b, { asChild: !0, children: /* @__PURE__ */ a("div", { className: e["alert-dialog-description"], children: [
              /* @__PURE__ */ i("div", { className: e["alert-dialog-content"], children: _ }),
              (o == null ? void 0 : o.children) && /* @__PURE__ */ i("div", { className: e["callout-container"], children: /* @__PURE__ */ i(I, { ...o }) })
            ] }) }),
            /* @__PURE__ */ a("div", { className: e["alert-dialog-actions"], children: [
              l && t && /* @__PURE__ */ i(c, { asChild: !0, children: /* @__PURE__ */ i(s, { color: "tertiary", onClick: t, children: l }) }),
              /* @__PURE__ */ i(c, { asChild: !0, children: /* @__PURE__ */ i(s, { isLoading: v, color: u, onClick: m, children: h }) })
            ] })
          ]
        }
      )
    ] })
  ] });
}
export {
  q as AlertDialog
};
